// Configuration using environment variables
const env = process.env.REACT_APP_ENV || 'production';
console.log(env);

let baseUrl = '';
let apiUrl = '';
let thawaniUrl = '';
let thawaniConfig = {};
let paymentSuccessUrl = '';
let paymentCancelledUrl = '';
let paymentSuccessUrlBulk = '';
let walletPaymentSuccessUrl = '';
let walletPaymentCancelledUrl = '';
let clientPaymentSuccessUrl = '';
let clientPaymentCancelledUrl = '';
let thawaniPaymentUrl = '';
let scopeUrl = '';
let oabPGurl = '';

switch (env.toLowerCase()) {
  case 'test':
    baseUrl = process.env.REACT_APP_TEST_BASE_URL || 'https://test.rop.mzadcom.om/';
    scopeUrl = process.env.REACT_APP_TEST_SCOPE_URL || baseUrl;
    apiUrl = baseUrl + 'services/public/api/';
    oabPGurl = baseUrl + 'pg/HostedPaymentCoreSubmit.php';
    thawaniUrl = process.env.REACT_APP_TEST_THAWANI_URL || 'https://uatcheckout.thawani.om/api/v1/';
    thawaniConfig = {
      'thawani-api-key': process.env.REACT_APP_TEST_THAWANI_API_KEY || 'rRQ26GcsZzoEhbrP2HZvLYDbn9C9et',
      publishable_key: process.env.REACT_APP_TEST_THAWANI_PUB_KEY || 'HGvTMLDssJghr9tlN9gr4DVYt0qyBy',
    };
    thawaniPaymentUrl = process.env.REACT_APP_TEST_THAWANI_PAYMENT_URL || 'https://uatcheckout.thawani.om/pay/';
    break;

  case 'dev':
    baseUrl = process.env.REACT_APP_DEV_BASE_URL || 'http://localhost:3000/';
    scopeUrl = process.env.REACT_APP_DEV_SCOPE_URL || baseUrl;
    apiUrl = process.env.REACT_APP_DEV_API_URL || 'http://localhost:8000/api/';
    oabPGurl = process.env.REACT_APP_DEV_OAB_URL || 'http://localhost/ROP/pg/HostedPaymentCoreSubmit.php';
    thawaniUrl = process.env.REACT_APP_DEV_THAWANI_URL || 'https://uatcheckout.thawani.om/api/v1/';
    thawaniConfig = {
      'thawani-api-key': process.env.REACT_APP_DEV_THAWANI_API_KEY || 'rRQ26GcsZzoEhbrP2HZvLYDbn9C9et',
      publishable_key: process.env.REACT_APP_DEV_THAWANI_PUB_KEY || 'HGvTMLDssJghr9tlN9gr4DVYt0qyBy',
    };
    thawaniPaymentUrl = process.env.REACT_APP_DEV_THAWANI_PAYMENT_URL || 'https://uatcheckout.thawani.om/pay/';
    break;

  case 'production':
  default:
    baseUrl = process.env.REACT_APP_PROD_BASE_URL || 'https://rop.mzadcom.om/';
    apiUrl = baseUrl + 'services/public/api/';
    oabPGurl = baseUrl + 'pg/HostedPaymentCoreSubmit.php';
    thawaniUrl = process.env.REACT_APP_PROD_THAWANI_URL || 'https://checkout.thawani.om/api/v1/';
    thawaniConfig = {
      'thawani-api-key': process.env.REACT_APP_PROD_THAWANI_API_KEY || 'SQeBH2iJiRsRS2r4yPClP1mHO1UkPH',
      publishable_key: process.env.REACT_APP_PROD_THAWANI_PUB_KEY || 'R0YzWOnB1HdUKZmiiQqnjuNJjscETk',
    };
    thawaniPaymentUrl = process.env.REACT_APP_PROD_THAWANI_PAYMENT_URL || 'https://checkout.thawani.om/pay/';
    break;
}

// Set URLs that follow the same pattern across environments
paymentSuccessUrl = baseUrl + 'payment-success/';
paymentSuccessUrlBulk = baseUrl + 'bulk-payment-success/';
paymentCancelledUrl = baseUrl + 'payment-cancelled';
walletPaymentSuccessUrl = baseUrl + 'wallet-payment-success/';
walletPaymentCancelledUrl = baseUrl + 'wallet-payment-cancelled';
clientPaymentSuccessUrl = baseUrl + 'client-payment-success/';
clientPaymentCancelledUrl = baseUrl + 'client-payment-cancelled';
scopeUrl = scopeUrl || baseUrl;

export {
  apiUrl,
  thawaniUrl,
  thawaniConfig,
  thawaniPaymentUrl,
  paymentSuccessUrl,
  paymentSuccessUrlBulk,
  paymentCancelledUrl,
  walletPaymentSuccessUrl,
  walletPaymentCancelledUrl,
  clientPaymentSuccessUrl,
  clientPaymentCancelledUrl,
  baseUrl,
  scopeUrl,
  oabPGurl,
};
